import type { IconType } from 'react-icons'
import type { IconBaseProps } from 'react-icons'
import { IconBase } from 'react-icons'

export const Integrations: IconType = (props: IconBaseProps) => (
  <IconBase {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1211 9.87891C16.6595 12.4173 16.6595 16.5329 14.1211 19.0713L13.7676 19.4248C11.2291 21.963 7.11353 21.9632 4.5752 19.4248C2.15608 17.0055 2.04394 13.1542 4.23633 10.6006L4.94531 11.3096C3.14192 13.4704 3.25456 16.6892 5.2832 18.7178C7.43104 20.8654 10.9126 20.8653 13.0605 18.7178L13.4141 18.3643C15.5619 16.2163 15.5619 12.7338 13.4141 10.5859L12.3535 9.52539L13.0605 8.81836L14.1211 9.87891ZM10.2324 4.5752C12.7707 2.03706 16.8865 2.03711 19.4248 4.5752C21.8442 6.99452 21.9551 10.8447 19.7627 13.3984L19.0547 12.6904C20.8579 10.5296 20.7462 7.31184 18.7178 5.2832C16.5699 3.13532 13.0873 3.13532 10.9395 5.2832L10.5859 5.63672C8.43843 7.78454 8.43843 11.2663 10.5859 13.4141L11.6455 14.4746L10.9395 15.1816L9.87891 14.1211C7.34085 11.5828 7.34084 7.46803 9.87891 4.92969L10.2324 4.5752Z"
        strokeWidth="1"
      />
    </svg>
  </IconBase>
)
